<template>
  <TBadge
    :variant="computedVariant"
    size="sm"
  >
    <img
      v-if="tag.IconUrl"
      :src="tag.IconUrl"
      alt=""
      class="size-4"
    >
    {{ getLocalizedText(tag.Title, locale) }}
  </TBadge>
</template>

<script setup lang="ts">
import type { BadgeVariant } from '~/components/_tailwind/badge/types'
import type { Rv } from '~/types/rv'

const props = defineProps<{
  tag: Rv['Tags'][number]
}>()

const { locale } = useI18n()

const computedVariant = computed<BadgeVariant>(() => {
  if (props.tag.Style === 'White') {
    return 'white'
  }
  if (props.tag.Style === 'Highlight') {
    return 'highlight'
  }
  return 'default'
})
</script>
